import React from 'react'
import { containerRepository } from '~/src/repositories'
import { TableContactOrderComponents } from './TableContactOrderComponents'
import useSWR from 'swr'
import { LoadingNormal } from '~/src/components/organisms'

interface IProps {
  userId: number
}

/**
 * TableContactOrder
 * @param userId
 * @constructor
 */
export const TableContactOrder: React.FC<IProps> = ({ userId }): JSX.Element => {
  const { data, error } = useSWR(
    [`/request-orders?userId=${userId}&excludeStatuses[]=400&excludeStatuses[]=1000`, userId],
    () => containerRepository.getContactOrder(userId)
  )

  if (!data && !error) {
    return <LoadingNormal />
  }
  if (error) {
    return <div>Failed to load Contact Order List</div>
  }
  return <TableContactOrderComponents data={data} />
}
